import { usePlayerContext } from '../context';
import { PlayerContext } from '../context/types';

/**
 * Hook to access the full PlayerContext value.
 * Use this when you need access to multiple player data fields or the reload function.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { progressSummary, reload } = usePlayer();
 *   // ...
 * }
 * ```
 */
export function usePlayer(): PlayerContext {
  return usePlayerContext();
}
